import { render, staticRenderFns } from "./add-book.vue?vue&type=template&id=03f1a94d&scoped=true&"
import script from "./add-book.vue?vue&type=script&lang=js&"
export * from "./add-book.vue?vue&type=script&lang=js&"
import style0 from "./add-book.vue?vue&type=style&index=0&id=03f1a94d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f1a94d",
  null
  
)

export default component.exports